import axios from "axios";
import { UpdateAccountFormType } from "ps-shared";

const api = process.env.PSYSUP_API;

// eslint-disable-next-line import/prefer-default-export
export class UserService {
  public static createVerificationSession(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${api}/user/verification`)
        .then((response: any) => {
          return resolve(response.data);
        })
        .catch((error: any) => {
          reject(error.response.data ? error.response.data : error);
        });
    });
  }

  public static getVerificationResult(sessionId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${api}/user/verification/${sessionId}`)
        .then((response: any) => {
          return resolve(response.data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public static updateAccount(form: UpdateAccountFormType): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .put(`${api}/user/account`, form)
        .then((response: any) => {
          return resolve(response.data);
        })
        .catch((error: any) => {
          reject(error.response.data ? error.response.data : error);
        });
    });
  }
}
